/**************************************************
 * Nombre:       Dialogo_Carrito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, useMediaQuery} from "@mui/material";
import {usePasosFormularios} from "../../Modulo_Pasos/Hooks/usePasosFormularios";
import Formulario_Lista_Productos from "../Formularios/Formulario_Lista_Productos";
import Formulario_Direccion from "../Formularios/Formulario_Direccion";
import {useState} from "react";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {useProductosCarrito} from "../Funcionamiento/Hooks/useProductosCarrito";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {envioNuevoPedido} from "../../Utilidades/envioNuevoPedido";
import Formulario_Totales from "../Formularios/Formulario_Totales";
import {envioDatosMercadoPago} from "../../Modulo_Mercado_Pago/Funciones/envioDatosMercadoPago";
import {irUrl} from "../../Utilidades/irUrl";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

const Dialogo_Carrito = ({cerrar}) => {
    const sCell = useMediaQuery(theme => theme.breakpoints.only('xs'));
    const {limpiarProductos} = useProductosCarrito()
    const {productos} = useProductosCarrito()
    const {Pasos, obtenerEntidad} = usePasosFormularios({
        datos: {productos: productos, guardar: true},
        formularios: [
            Formulario_Lista_Productos,
            Formulario_Direccion,
            Formulario_Totales
        ]
    })
    const {Cargador, Avisos, iniciarCarga, terminar} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: limpiarProductos
    })
    const [cargando, setCargando] = useState(false)

    const subirDatosCarrito = async (e) => {

        iniciarCarga('Subiendo Pedido')
        e.estado = 'Nuevo'
        let doxConse = await obtenerConsecutivo({col: 'consecutivos', id: 'pedidos'})
        e.consecutivo = doxConse.data


        let dox = await guardarDoc('pedidos', e)
        await aumentarConsecutivo({col: 'consecutivos', id: 'pedidos', actual: doxConse.data})
        await envioNuevoPedido(e)
        if (dox.res) {
            e.id = dox.data
            let data = await envioDatosMercadoPago(e)
            console.log(data)
            if (data && data.respuesta) {
                irUrl(data.respuesta)
            }
            terminar({aviso: 'Pedido realizado, sigue el proceso con mercado pago'})
            setTimeout(() => {
                // cerrar()
            }, 3000)
        } else {
            terminar({aviso: 'Algo salio mal, intentalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >


            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: sCell ? 1 : 3, mt: 2}}>
                <Pasos finalizar={subirDatosCarrito} cargando={cargando}/>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Carrito